export const preNotificationAvailable = value => dispatch => dispatch({ type: 'PRE_NOTIFICATION_AVAILABLE', value });
export const preNotificationCookie = value => dispatch => dispatch({ type: 'PRE_NOTIFICATION_COOKIE', value });
